import type { ParallaxElementConfig } from 'parallax-controller'
import type { InjectionKey } from 'vue'

export const ParallaxLayerKey: InjectionKey<Ref<ParallaxElementConfig | undefined>>
  = Symbol('ParallaxLayerKey')
